import { createContext, ReactNode, useMemo } from 'react';

interface IRadioContext {
  selectedValue?: string;
  setSelectedValue?: (value: string) => void;
  name: string;
}

export const RadioContext = createContext<IRadioContext>({} as IRadioContext);

interface IRadioContextProviderProps {
  children: ReactNode;
  value: IRadioContext;
}

export const RadioContextProvider = ({
  children,
  value: { name, setSelectedValue, selectedValue },
}: IRadioContextProviderProps) => {
  const contextValue = useMemo(
    () => ({ name, selectedValue, setSelectedValue }),
    [name, selectedValue, setSelectedValue],
  );
  return <RadioContext.Provider value={contextValue}>{children}</RadioContext.Provider>;
};
